import { ruleConditions } from './rule-conditions.js';
import { templateFieldPhaseRank } from './template-field-phase-rank.js';
import { templateFieldPhase } from './template-field-phase.js';
const LATER_PHASE_TIMING = {
    beforeStart: 'before the event starts',
    afterStart: 'after the event starts',
};
function laterPhaseTiming(fieldId, fields) {
    const phase = templateFieldPhase(fields.find((candidate) => candidate.id === fieldId)?.config);
    return phase === 'creation' ? 'later' : LATER_PHASE_TIMING[phase];
}
/** A rule cannot read a field due later than its target or pre-fill a non-creation one: neither has a value when the event is created. */
export function rulePhaseErrors(rule, fields) {
    const errors = [];
    const targetRank = templateFieldPhaseRank(rule.targetFieldId, fields);
    for (const { fieldId } of ruleConditions(rule)) {
        if (templateFieldPhaseRank(fieldId, fields) > targetRank) {
            errors.push(`Rule on "${rule.targetFieldId}" cannot depend on "${fieldId}" — that field is only filled in ${laterPhaseTiming(fieldId, fields)}.`);
        }
    }
    if (rule.type === 'defaultValueIf' && targetRank > 0) {
        errors.push(`defaultValueIf cannot target "${rule.targetFieldId}" — it is filled in ${laterPhaseTiming(rule.targetFieldId, fields)}, so nothing is pre-filled for it.`);
    }
    return errors;
}
//# sourceMappingURL=rule-phase-errors.js.map